import React, {useState} from 'react';
import axios from 'axios';
import AutoSuggestField from '@FormComponents/AutoSuggestField';

const LocationAutoSuggest = ({settings, ...rest}) => {
  const [data, setData] = useState([]);
  const {name, setState} = settings || {};

  rest.onChange = (e) => {
    const {value} = e.target;
    if (value && value.length) {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/getLocationAutocomplete',
        currentRoute: {},
        data: {
          searchText: e.target.value,
        },
      }).then((response) => {
        if (response.data.length) {
          setData(response.data);
        }
      });
    }
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  settings.options = data;

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
};

export default LocationAutoSuggest;
